'use client';

import React, { useEffect, useState } from 'react';

import {
  NotificationEnum,
  NotificationResponseType,
  NotificationType,
} from '@/api/services/GlobalService/types';
import Link from '@/components/core/Link';
import { useTranslation } from '@/hooks/useTranslations';

import { getNotifications as requestNotifications } from '../notificationsRequest';

const NotificationPanel = () => {
  const [notification, setNotification] = useState<NotificationType | null>();
  const { t } = useTranslation();

  const getNotifications = async () => {
    try {
      const data: NotificationResponseType = await requestNotifications();

      if (data?.query?.length && typeof window !== 'undefined') {
        // @ts-ignore
        const notification: NotificationType | undefined = data.query.find(
          // @ts-ignore
          ({ type }) => type === NotificationEnum.NotificationPanel
        );
        setNotification(notification);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const handleCloseNotificationPanel = () => {
    if (typeof window !== 'undefined') {
      setNotification(null);
      sessionStorage.setItem('hideNotificationPanel', JSON.stringify(true));
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hideNotificationPanel = sessionStorage.getItem('hideNotificationPanel');
      !hideNotificationPanel && getNotifications();
    }
  }, []);

  return (
    notification && (
      <div className="notification-section-wrp">
        <div className="bigContent">
          <div className="notification-section-holder">
            <div className="notification-section-info">
              <div className="notification-section-info-inner">
                <p className="notification-section-info-txt">{notification?.description}</p>
                <div className="notification-section-btn-block">
                  <Link href={notification.submitUrl} className="button btnTypeSmall btnTypeCopy">
                    <p>{t('Homepage-Button-Readmore')}</p>
                  </Link>
                </div>
              </div>
            </div>
            <div className="notification-section-close-block">
              <i className="bc-i-close" onClick={handleCloseNotificationPanel} />
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default NotificationPanel;
